module.exports = __webpack_public_path__ + "static/media/box-usd.9758fe59.svg";